import { render, staticRenderFns } from "./device-info.vue?vue&type=template&id=c666781c&scoped=true&"
import script from "./device-info.vue?vue&type=script&lang=js&"
export * from "./device-info.vue?vue&type=script&lang=js&"
import style0 from "./device-info.vue?vue&type=style&index=0&id=c666781c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c666781c",
  null
  
)

export default component.exports